export const LOAD_SITE_SITE_ZONES = 'LOAD_SITE_SITE_ZONES';
export const LOAD_SITE_LOCAL_MAP_ZONES = 'LOAD_SITE_LOCAL_MAP_ZONES';
